import {
  Box,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Typography,
} from '@mui/material'
import ShieldCheckIcon from '@mui/icons-material/Shield'
import { useNavigate } from 'react-router-dom'

const AdministracaoPage: React.FC = () => {
  const navigate = useNavigate()

  const options = [
    {
      key: 'permissoes',
      title: 'Permissões por grupo e usuário',
      description: 'Administrar permissões por grupo e usuário para a empresa escolhida.',
      icon: <ShieldCheckIcon fontSize="large" color="primary" />,
      action: () => navigate('/administracao/permissoes'),
      buttonText: 'Abrir',
    },
  ]

  return (
    <Box sx={{ py: 4, px: { xs: 2, md: 3 }, width: '100%' }}>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Administração da empresa
      </Typography>
      <Grid container spacing={3}>
        {options.map((opt) => (
          <Grid item xs={12} sm={6} md={4} key={opt.key}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ mb: 2 }}>{opt.icon}</Box>
                <Typography variant="h6" gutterBottom>
                  {opt.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {opt.description}
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small" variant="contained" onClick={opt.action}>
                  {opt.buttonText}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default AdministracaoPage
